import React from 'react';
import LegalPage from './LegalPage';

const RefundCancellationPolicy = () => (
  <LegalPage title="Refund and Cancellation Policy" updated="23 June 2026">
    <p>
      This Refund and Cancellation Policy applies to services provided by
      ContextJet AI.
    </p>

    <h2>1. Nature of Services</h2>
    <p>
      ContextJet AI provides custom software development, AI development,
      automation, NLP, and IT consulting services.
    </p>
    <p>
      Our services are custom-built based on client requirements. Therefore,
      refunds and cancellations are handled based on the stage of work
      completed and the terms agreed with the client.
    </p>

    <h2>2. No Physical Shipping</h2>
    <p>We provide digital services only. No physical products are shipped.</p>
    <p>
      Project deliverables may be delivered through email, cloud storage,
      source code repositories, project management tools, deployment
      environments, or other agreed digital channels.
    </p>

    <h2>3. Cancellation Before Work Starts</h2>
    <p>
      If a client cancels a project before any work has started, a refund may
      be issued after deducting any payment gateway charges, bank charges,
      administrative costs, or third-party expenses already incurred.
    </p>

    <h2>4. Cancellation After Work Starts</h2>
    <p>
      If work has started, payments made for completed work, time spent,
      planning, research, consultation, development, design, project
      management, or third-party expenses are generally non-refundable.
    </p>
    <p>
      Any refund, if applicable, will be calculated after reviewing the
      completed work and costs incurred.
    </p>

    <h2>5. Milestone-Based Projects</h2>
    <p>
      For milestone-based projects, payments made for completed or approved
      milestones are non-refundable.
    </p>
    <p>
      If a project is cancelled before completion of a pending milestone, the
      refund amount, if any, will depend on work completed up to the
      cancellation date.
    </p>

    <h2>6. Advance Payments</h2>
    <p>
      Advance payments are used to reserve project time, start planning,
      allocate resources, and begin work. Advance payments may be
      non-refundable once work has started.
    </p>

    <h2>7. Third-Party Costs</h2>
    <p>
      Payments made for third-party services such as hosting, APIs, cloud
      services, software licenses, domains, subscriptions, integrations, or
      external tools are non-refundable once purchased or consumed.
    </p>

    <h2>8. Refund Timeline</h2>
    <p>
      If a refund is approved, it will be processed within 7 to 15 business
      days to the original payment method or another mutually agreed method.
    </p>
    <p>
      The actual time taken for the amount to reflect may depend on banks,
      payment gateways, or international transfer systems.
    </p>

    <h2>9. Chargebacks and Disputes</h2>
    <p>
      Clients are requested to contact us first for any payment or service
      concern before raising a chargeback or dispute.
    </p>

    <h2>10. Contact</h2>
    <p>For refund or cancellation requests, please contact:</p>
    <ul>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>
    <p>
      Please include your invoice number, payment date, project name, and
      reason for the request.
    </p>
  </LegalPage>
);

export default RefundCancellationPolicy;
